import { Box, Icon, Text } from '@chakra-ui/react';
import { IoReceiptOutline } from 'react-icons/io5';

const StepperRestingStep = (): JSX.Element => {
  return (
    <Box
      alignSelf={'flex-end'}
      gap={6}
      display="flex"
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      mt={8}
    >
      <Icon as={IoReceiptOutline} boxSize={'80px'} />
      <Text fontWeight={500} fontSize={'1.75rem'} textAlign={'center'}>
        Paga tus facturas
      </Text>
      <Text textAlign={'center'}>Selecciona la factura que deseas pagar para iniciar el pago</Text>
    </Box>
  );
};

export default StepperRestingStep;
